import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'font-awesome/css/font-awesome.min.css';

import React from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate } from "react-router-dom";
import { Link as ScrollLink } from 'react-scroll';
import logo from "../../../Assets/logo.png";

const NavbarStyles = {
  background: 'linear-gradient(to left, #2c3e50, #3498db)',
  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',  
};

// Shared styles for responsive navigation
const navStyles = {
  navContainer: "text-center text-lg-end w-100",
  navItems: "d-flex flex-column flex-md-row gap-3 p-2 justify-content-center justify-content-lg-end w-100",
  navLink: "px-3 py-2 d-flex align-items-center gap-2 text-white mx-auto mx-lg-0",
  navDropdown: "mx-auto mx-lg-0 me-lg-2 border-0"
};

const globalStyles = document.createElement('style');
globalStyles.innerHTML = `
  .hover-grow {
    transition: transform 0.3s ease;
  }
  .hover-grow:hover {
    transform: scale(1.05);
  }
`;
document.head.appendChild(globalStyles);

const LogoComponent = ({ onClick }) => {
  const logoStyle = {
    transition: 'transform 0.3s ease',
    maxHeight: '50px',
    maxWidth: '150px',
    display: 'inline-block',
    verticalAlign: 'top'
  };
  
  return (
    <div 
      className="navbar-brand fw-bold fs-3 text-center" 
      style={{ cursor: 'pointer' }}
      onClick={onClick}
    >
      <img 
        src={logo} 
        style={logoStyle}
        className="d-inline-block align-top hover-grow" 
        alt="Value Craft Minds Logo" 
      />
    </div>
  );
};

const CustomNavbar = ({ children }) => {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const auditor = JSON.parse(localStorage.getItem("auditor"));
  const dUser = JSON.parse(localStorage.getItem("dUser"));
  const accountType = user?.accountType;
  const auditorRole = auditor?.role;
  const auditorAccountType = auditor?.accountType;
  const dUserRole = dUser?.role;
  const dUserAccountType = dUser?.accountType;

  const handleLogout = () => {     
    localStorage.removeItem("user");
    localStorage.removeItem("auditor");
    localStorage.removeItem("dUser");

    navigate("/");    
  };

  //main page navbar
  const MainNavbar = () => {
    const navigate = useNavigate();

    const handleNavigation = (section) => {
      if (window.location.pathname !== '/HomePage') {
        navigate('/HomePage');
        setTimeout(() => {
          document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        // If already on HomePage, just scroll to section
        document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
      }
    };

    return (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent 
  onClick={() => {
    navigate('/HomePage');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  }}
/>
          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <ScrollLink
                  to="home"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={100}
                >
                  <Button 
                    variant="link" 
                    className={navStyles.navLink}
                    onClick={() => handleNavigation('home')}
                    style={{ textDecoration: 'none' }}
                  >
                    Home
                  </Button>
                </ScrollLink>

                <ScrollLink
                  to="overview"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={100}
                >
                  <Button 
                    variant="link" 
                    className={navStyles.navLink}
                    onClick={() => handleNavigation('overview')}
                    style={{ textDecoration: 'none' }}
                  >
                    Overview
                  </Button>
                </ScrollLink>

                <ScrollLink
                  to="features"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={100}
                >
                  <Button 
                    variant="link" 
                    className={navStyles.navLink}
                    onClick={() => handleNavigation('features')}
                    style={{ textDecoration: 'none' }}
                  >
                    Features
                  </Button>
                </ScrollLink>

                <ScrollLink
                  to="pricing"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={100}
                >
                  <Button 
                    variant="link" 
                    className={navStyles.navLink}
                    onClick={() => handleNavigation('pricing')}
                    style={{ textDecoration: 'none' }}
                  >
                    Pricing
                  </Button>
                </ScrollLink>

                <ScrollLink
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={100}
                >
                  <Button 
                    variant="link" 
                    className={navStyles.navLink}
                    onClick={() => handleNavigation('contact')}
                    style={{ textDecoration: 'none' }}
                  >
                    Contact us
                  </Button>
                </ScrollLink>

                <Button 
                  variant="outline-light" 
                  className="px-3 py-2 d-flex align-items-center gap-2 mx-auto mx-lg-0" 
                  onClick={() => navigate('/LoginTabs')}
                >
                  Login
                </Button>
                <Button 
                  variant="outline-light" 
                  className="px-3 py-2 d-flex align-items-center gap-2 mx-auto mx-lg-0" 
                  onClick={() => navigate('/RegisterTabs')}
                >
                  Register
                </Button>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };

  //Navbar for individual account
  const IndividualNavbar = () => (
    <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
      <Container fluid>
      <LogoComponent onClick={() => navigate('/IndividualDashboard')} />

        
        <Navbar.Toggle aria-controls="plant-navbar-nav"/>
        <Navbar.Collapse id="plant-navbar-nav">
          <Nav className={navStyles.navContainer}>
            <div className={navStyles.navItems}>
              <Button 
                variant="link" 
                className={navStyles.navLink} 
                onClick={() => navigate('/IndividualDashboard')}
                style={{ textDecoration: 'none' }}
              >
                Dashboard
              </Button>
              
              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">                    
                    Branch
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate("/IndividualBranch")} className="d-flex align-items-center gap-2">
                  Branch
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/IndividualDepartment")} className="d-flex align-items-center gap-2">              
                  Department
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/IndividualStructure")} className="d-flex align-items-center gap-2">                
                  Company Structure
                </NavDropdown.Item>               
              </NavDropdown>

              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">                    
                    User
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate("/IndividualDepartmentUser")} className="d-flex align-items-center gap-2">
                  Department User
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/IndividualAuditorCreate")} className="d-flex align-items-center gap-2">              
                  Auditor
                </NavDropdown.Item>         
              </NavDropdown>

              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">                    
                    Checklist
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate("/ChecklistOverview")} className="d-flex align-items-center gap-2">
                  Checklist
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/QuestionsPage")} className="d-flex align-items-center gap-2">              
                  Questions
                </NavDropdown.Item>             
              </NavDropdown>
              <Button 
              variant="link" 
              className={navStyles.navLink} 
              onClick={() => navigate("/IndividualAuditOverview")}
              style={{ textDecoration: 'none' }}
            >
              Audit
            </Button>

              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">
                   
                    {user ? `${user.firstName} ${user.lastName}` : "Guest User"}
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate(`/IndividualUserProfile/${user?.id}`)} className="d-flex align-items-center gap-2">
                  UserProfile
                </NavDropdown.Item>   
                <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                  Logout
                </NavDropdown.Item>                      
              </NavDropdown>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
  
  //Navbar for business account
  const BusinessNavbar = () => (
    <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
      <Container fluid>
      <LogoComponent onClick={() => navigate('/BusinessDashboard')} />

        
        <Navbar.Toggle aria-controls="plant-navbar-nav"/>
        <Navbar.Collapse id="plant-navbar-nav">
          <Nav className={navStyles.navContainer}>
            <div className={navStyles.navItems}>
              <Button 
                variant="link" 
                className={navStyles.navLink} 
                onClick={() => navigate('/BusinessDashboard')}
                style={{ textDecoration: 'none' }}
              >
                Dashboard
              </Button>
              
              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">                    
                    Branch
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate("/BusinessBranch")} className="d-flex align-items-center gap-2">
                  Branch
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/BusinessDepartment")} className="d-flex align-items-center gap-2">              
                  Department
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/BusinessStructure")} className="d-flex align-items-center gap-2">                
                  Company Structure
                </NavDropdown.Item>               
              </NavDropdown>

              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">                    
                    User
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate("/BusinessDepartmentUser")} className="d-flex align-items-center gap-2">
                  Department User
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/BusinessAuditorCreate")} className="d-flex align-items-center gap-2">              
                  Auditor
                </NavDropdown.Item>         
              </NavDropdown>

              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">                    
                    Checklist
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate("/BusinessChecklistOverview")} className="d-flex align-items-center gap-2">
                  Checklist
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/BusinessQuestionsPage")} className="d-flex align-items-center gap-2">              
                  Questions
                </NavDropdown.Item>             
              </NavDropdown>
              <Button 
              variant="link" 
              className={navStyles.navLink} 
              onClick={() => navigate("/BusinessAuditOverview")}
              style={{ textDecoration: 'none' }}
            >
              Audit
            </Button>

              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">
                    {user ? `${user.company}` : "Guest User"}
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate(`/BusinessUserProfile/${user?.id}`)} className="d-flex align-items-center gap-2">
                  UserProfile
                </NavDropdown.Item>   
                <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                  Logout
                </NavDropdown.Item>                      
              </NavDropdown>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );


    //Navbar for Factory account
const FactoryNavbar = () => (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent onClick={() => navigate('/FactoryDashboard')} />
  
          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/FactoryDashboard')}
                  style={{ textDecoration: 'none' }}
                >
                  Dashboard
                </Button>
                
                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">                    
                      Branch
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate("/FactoryBranch")} className="d-flex align-items-center gap-2">
                    Branch
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/FactoryDepartment")} className="d-flex align-items-center gap-2">              
                    Department
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/FactoryStructure")} className="d-flex align-items-center gap-2">                
                    Company Structure
                  </NavDropdown.Item>               
                </NavDropdown>
  
                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">                    
                      User
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate("/FactoryDepartmentUser")} className="d-flex align-items-center gap-2">
                    Department User
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/FactoryAuditorCreate")} className="d-flex align-items-center gap-2">              
                    Auditor
                  </NavDropdown.Item> 
                  <NavDropdown.Item onClick={() => navigate("/FactoryBranchAdmin")} className="d-flex align-items-center gap-2">              
                    Branch Admin
                  </NavDropdown.Item>         
                </NavDropdown>
  
                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">                    
                      Checklist
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate("/FactoryChecklistOverview")} className="d-flex align-items-center gap-2">
                    Checklist
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/FactoryQuestionsPage")} className="d-flex align-items-center gap-2">              
                    Questions
                  </NavDropdown.Item>             
                </NavDropdown>
                <Button 
                variant="link" 
                className={navStyles.navLink} 
                onClick={() => navigate("/FactoryAuditOverview")}
                style={{ textDecoration: 'none' }}
              >
                Audit
              </Button>
  
                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">
                      {user ? `${user.factory}` : "Guest User"}
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate(`/FactoryUserProfile/${user?.id}`)} className="d-flex align-items-center gap-2">
                    UserProfile
                  </NavDropdown.Item>   
                  <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                    Logout
                  </NavDropdown.Item>                      
                </NavDropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );


  //Navbar for individual account
  const JBranchNavbar = () => (
    <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
      <Container fluid>
      <LogoComponent onClick={() => navigate('/JBranchDashboard')} />

        
        <Navbar.Toggle aria-controls="plant-navbar-nav"/>
        <Navbar.Collapse id="plant-navbar-nav">
          <Nav className={navStyles.navContainer}>
            <div className={navStyles.navItems}>
              <Button 
                variant="link" 
                className={navStyles.navLink} 
                onClick={() => navigate('/JBranchDashboard')}
                style={{ textDecoration: 'none' }}
              >
                Dashboard
              </Button>
              
              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">                    
                    Branch
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate("/JBranchBranch")} className="d-flex align-items-center gap-2">
                  Branch
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/JBranchDepartment")} className="d-flex align-items-center gap-2">              
                  Department
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/JBranchStructure")} className="d-flex align-items-center gap-2">                
                  Company Structure
                </NavDropdown.Item>               
              </NavDropdown>

              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">                    
                    User
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate("/JBranchDepartmentUser")} className="d-flex align-items-center gap-2">
                  Department User
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/JBranchAuditorCreate")} className="d-flex align-items-center gap-2">              
                  Auditor
                </NavDropdown.Item>         
              </NavDropdown>

              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">                    
                    Checklist
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate("/JBranchChecklistOverview")} className="d-flex align-items-center gap-2">
                  Checklist
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate("/JBranchQuestionsPage")} className="d-flex align-items-center gap-2">              
                  Questions
                </NavDropdown.Item>             
              </NavDropdown>
              <Button 
              variant="link" 
              className={navStyles.navLink} 
              onClick={() => navigate("/JBranchAuditOverview")}
              style={{ textDecoration: 'none' }}
            >
              Audit
            </Button>

              <NavDropdown 
                title={
                  <span className="text-white align-items-center gap-2">
                   
                    {user ? `${user.firstName} ${user.lastName}` : "Guest User"}
                  </span>
                } 
                id="users-dropdown" 
                className={navStyles.navDropdown}
              >
                <NavDropdown.Item onClick={() => navigate(`/JBranchUserProfile/${user?.id}`)} className="d-flex align-items-center gap-2">
                  UserProfile
                </NavDropdown.Item>   
                <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                  Logout
                </NavDropdown.Item>                      
              </NavDropdown>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );






  //Individual auditor navbar
  const IndividualAuditorNavbar = () => {
    const auditor = JSON.parse(localStorage.getItem("auditor"));
    
    return (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent onClick={() => navigate('/InAuditorDashboard')} />

          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/InAuditorDashboard')}
                  style={{ textDecoration: 'none' }}
                >
                  Dashboard
                </Button>

                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/AuditChecklist', { state: { activeTab: 'pending' } })}
                  style={{ textDecoration: 'none' }}
                >
                  My Audit
                </Button>

                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/ReAuditChecklist', { state: { activeTab: 'pending' } })}
                  style={{ textDecoration: 'none' }}
                >
                  My CAP
                </Button>

                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">
                      {auditor ? `${auditor.firstName} ${auditor.lastName}` : "Guest Auditor"}
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate(`/InAuditorUserProfile/${auditor?.id}`)} className="d-flex align-items-center gap-2">
                    Profile
                  </NavDropdown.Item>   
                  <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                    Logout
                  </NavDropdown.Item>                      
                </NavDropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };

  const BusinessAuditorNavbar = () => {
    const auditor = JSON.parse(localStorage.getItem("auditor"));
    
    return (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent onClick={() => navigate('/BusinessAuditorDashboard')} />

          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/BusinessAuditorDashboard')}
                  style={{ textDecoration: 'none' }}
                >
                  Dashboard
                </Button>

                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/BusinessAuditChecklist')}
                  style={{ textDecoration: 'none' }}
                >
                  My Audit
                </Button>

                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/BusinessReAuditChecklist')}
                  style={{ textDecoration: 'none' }}
                >
                  My CAP
                </Button>

                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">
                      {auditor ? `${auditor.firstName} ${auditor.lastName}` : "Guest Auditor"}
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate(`/BusinessAuditorUserProfile/${auditor?.id}`)} className="d-flex align-items-center gap-2">
                    Profile
                  </NavDropdown.Item>   
                  <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                    Logout
                  </NavDropdown.Item>                      
                </NavDropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };


  const FactoryAuditorNavbar = () => {
    const auditor = JSON.parse(localStorage.getItem("auditor"));
    
    return (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent onClick={() => navigate('/FactoryAuditorDashboard')} />
  
          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/FactoryAuditorDashboard')}
                  style={{ textDecoration: 'none' }}
                >
                  Dashboard
                </Button>
  
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/FactoryAuditChecklist')}
                  style={{ textDecoration: 'none' }}
                >
                  My Audit
                </Button>
  
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/FactoryReAuditChecklist')}
                  style={{ textDecoration: 'none' }}
                >
                  My CAP
                </Button>
  
                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">
                      {auditor ? `${auditor.firstName} ${auditor.lastName}` : "Guest Auditor"}
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate(`/FactoryAuditorUserProfile/${auditor?.id}`)} className="d-flex align-items-center gap-2">
                    Profile
                  </NavDropdown.Item>   
                  <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                    Logout
                  </NavDropdown.Item>                      
                </NavDropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };


  const JBranchAuditorNavbar = () => {
    const auditor = JSON.parse(localStorage.getItem("auditor"));
    
    return (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent onClick={() => navigate('/JBranchAuditorDashboard')} />

          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/JBranchAuditorDashboard')}
                  style={{ textDecoration: 'none' }}
                >
                  Dashboard
                </Button>

                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/JBranchAuditChecklist')}
                  style={{ textDecoration: 'none' }}
                >
                  My Audit
                </Button>

                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/JBranchReAuditChecklist')}
                  style={{ textDecoration: 'none' }}
                >
                  My CAP
                </Button>

                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">
                      {auditor ? `${auditor.firstName} ${auditor.lastName}` : "Guest Auditor"}
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate(`/JBranchAuditorUserProfile/${auditor?.id}`)} className="d-flex align-items-center gap-2">
                    Profile
                  </NavDropdown.Item>   
                  <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                    Logout
                  </NavDropdown.Item>                      
                </NavDropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };


  const IndividualDuserNavbar = () => {
    const dUser = JSON.parse(localStorage.getItem("dUser"));
    
    return (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent onClick={() => navigate('/InDuserDashboard')} />

          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/InDuserDashboard')}
                  style={{ textDecoration: 'none' }}
                >
                  Dashboard
                </Button>

                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/InDuserAudit')}
                  style={{ textDecoration: 'none' }}
                >
                  Audit
                </Button>
                
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/InDuserReAudit')}
                  style={{ textDecoration: 'none' }}
                >
                  ReAudit
                </Button>


                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">
                      {dUser ? `${dUser.firstName} ${dUser.lastName}` : "Guest dUser"}
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate(`/InDuserProfile/${dUser?.id}`)} className="d-flex align-items-center gap-2">
                    Profile
                  </NavDropdown.Item>   
                  <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                    Logout
                  </NavDropdown.Item>                      
                </NavDropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };

  const BusinessDuserNavbar = () => {
    const dUser = JSON.parse(localStorage.getItem("dUser"));
    
    return (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent onClick={() => navigate('/BusinessDuserDashboard')} />
  
          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/BusinessDuserDashboard')}
                  style={{ textDecoration: 'none' }}
                >
                  Dashboard
                </Button>
  
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/BusinessDuserAudit')}
                  style={{ textDecoration: 'none' }}
                >
                  Audit
                </Button>
                
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/BusinessDuserReAudit')}
                  style={{ textDecoration: 'none' }}
                >
                  ReAudit
                </Button>
  
  
                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">
                      {dUser ? `${dUser.firstName} ${dUser.lastName}` : "Guest dUser"}
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate(`/BusinessDuserProfile/${dUser?.id}`)} className="d-flex align-items-center gap-2">
                    Profile
                  </NavDropdown.Item>   
                  <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                    Logout
                  </NavDropdown.Item>                      
                </NavDropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };


  const FactoryDuserNavbar = () => {
    const dUser = JSON.parse(localStorage.getItem("dUser"));
    
    return (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent onClick={() => navigate('/FactoryDuserDashboard')} />
  
          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/FactoryDuserDashboard')}
                  style={{ textDecoration: 'none' }}
                >
                  Dashboard
                </Button>
  
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/FactoryDuserAudit')}
                  style={{ textDecoration: 'none' }}
                >
                  Audit
                </Button>
                
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/FactoryDuserReAudit')}
                  style={{ textDecoration: 'none' }}
                >
                  ReAudit
                </Button>
  
  
                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">
                      {dUser ? `${dUser.firstName} ${dUser.lastName}` : "Guest dUser"}
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate(`/FactoryDuserProfile/${dUser?.id}`)} className="d-flex align-items-center gap-2">
                    Profile
                  </NavDropdown.Item>   
                  <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                    Logout
                  </NavDropdown.Item>                      
                </NavDropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };


  const JBranchDuserNavbar = () => {
    const dUser = JSON.parse(localStorage.getItem("dUser"));
    
    return (
      <Navbar style={NavbarStyles} variant="dark" expand="lg" sticky="top" className="py-2">
        <Container fluid>
        <LogoComponent onClick={() => navigate('/JBranchDuserDashboard')} />
  
          
          <Navbar.Toggle aria-controls="plant-navbar-nav"/>
          <Navbar.Collapse id="plant-navbar-nav">
            <Nav className={navStyles.navContainer}>
              <div className={navStyles.navItems}>
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/JBranchDuserDashboard')}
                  style={{ textDecoration: 'none' }}
                >
                  Dashboard
                </Button>
  
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/JBranchDuserAudit')}
                  style={{ textDecoration: 'none' }}
                >
                  Audit
                </Button>
                
                <Button 
                  variant="link" 
                  className={navStyles.navLink} 
                  onClick={() => navigate('/JBranchDuserReAudit')}
                  style={{ textDecoration: 'none' }}
                >
                  ReAudit
                </Button>
  
  
                <NavDropdown 
                  title={
                    <span className="text-white align-items-center gap-2">
                      {dUser ? `${dUser.firstName} ${dUser.lastName}` : "Guest dUser"}
                    </span>
                  } 
                  id="users-dropdown" 
                  className={navStyles.navDropdown}
                >
                  <NavDropdown.Item onClick={() => navigate(`/JBranchDuserProfile/${dUser?.id}`)} className="d-flex align-items-center gap-2">
                    Profile
                  </NavDropdown.Item>   
                  <NavDropdown.Item onClick={handleLogout} className="d-flex align-items-center gap-2">
                    Logout
                  </NavDropdown.Item>                      
                </NavDropdown>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  };







  
  return (
    <>
      {(!user && !auditor && !dUser ) && <MainNavbar />}
      {(accountType === "individual") && <IndividualNavbar />}
      {(accountType === "business") && <BusinessNavbar />}
      {(accountType === "factory") && <FactoryNavbar />}
      {(accountType === "Joined Branch") && <JBranchNavbar />}

      {(auditorRole === "Branch auditor" && auditorAccountType==="individual") && <IndividualAuditorNavbar />}
      {(auditorRole === "Company auditor" && auditorAccountType==="business") && <BusinessAuditorNavbar />}
      {(auditorRole === "Factory auditor" && auditorAccountType==="factory") && <FactoryAuditorNavbar />}
      {(auditorRole === "Branch auditor" && auditorAccountType==="Joined Branch") && <JBranchAuditorNavbar />}


      {(dUserRole === "Department user" && dUserAccountType==="individual") && <IndividualDuserNavbar />}
      {(dUserRole === "Department user" && dUserAccountType==="business") && <BusinessDuserNavbar />}
      {(dUserRole === "Department user" && dUserAccountType==="factory") && <FactoryDuserNavbar />}
      {(dUserRole === "Department user" && dUserAccountType==="Joined Branch") && <JBranchDuserNavbar />}

    </>
  );
};

export default CustomNavbar;